let booleanHandle = (value)=>{
    if (value){
        return '是'
    }
    else {
        return '否'
    }
}
let sexHandle = (value)=>{
    if (value == 0){
        return '男'
    }
    else {
        return '女'
    }
}
export {
    booleanHandle,
    sexHandle
}
